import React from 'react';
import styled from 'styled-components';
import Img from '../components/Img';
import OuterLink from '../components/OuterLink';
import {Container} from '../styles/Grids';
import {breakPoint} from '../styles/var';

// images
import img_title from '../assets/img/pc07-1.png';
import img_btn_more from '../assets/img/pc07-2.png';
import img_bg from '../assets/img/bg.png';

const ContentStyles = styled.div`
  position: relative;
  background-color: #EDD6C8;
  background-image: url(${img_bg});
  background-repeat: no-repeat;
  background-position: center center;
  margin-bottom: 4rem;
  .container {
    padding: 16rem 4rem 12rem;
    > .title {
      text-align: left;
    }
  }
  .desc {
    display: flex;
    align-items: center;
  }

  @media (min-width: ${breakPoint.min}) {
    .container {
      >.title {
        margin-bottom: 4rem;
      }
    }
    .desc {
      h3 {
        font-size: 4rem;
        margin-right: 4rem;
      }
    }
  }
  @media (max-width: ${breakPoint.smMax}) {
    padding-top: 4rem;
    padding-bottom: 3rem;
    margin-bottom: 4rem;
    background-size: cover;
    .container {
      padding: 3rem 2rem;
      > .title {
        max-width: 50%;
        margin-left: 0;
        margin-bottom: 2rem;
      }
      > .desc {
        width: 100%;
        h3 {
          margin-right: 2rem;
        }
        .btn {
          max-width: 38%;
        }
      }
    }
  }
`;


const Section6 = (props) => {
  return (
      <ContentStyles {...props}>
        <Container className="container">
          <Img src={img_title} wrapProps={{className: 'title'}}/>
            <div className="desc">
                <h3>分享親子育兒生活</h3>
                <OuterLink href={'https://www.surveycake.com/s/g0RP0'} className={'btn'}>
                    <Img src={img_btn_more}/>
                </OuterLink>
            </div>
        </Container>
      </ContentStyles>
  )
};

export default Section6;
